import React from 'react';
import { useParallax } from '../lib/scrollFX';

const DEFAULT_PARAGRAPHS = [
  "I'm a software engineer who loves building from scratch — " +
    "clean systems, thoughtful products, and tools that make people's " +
    'lives a little easier. I care deeply about the craft and about ' +
    'shipping things that actually matter.',
  "When I'm not writing code, I'm probably reading, exploring ideas, " +
    "hanging with my dog, or thinking about what to build next. Life's " +
    "too short to stress — I'm here to build cool things and enjoy the " +
    'ride.',
];

const DEFAULT_TERMINAL_LINES = [
  { prompt: 'whoami', output: 'engineer · ai builder · dog dad', highlight: false },
  { prompt: 'status --now', output: '▸ shipping things that matter', highlight: true },
];

export default function About({ content }) {
  const cardRef = useParallax();

  const heading = content?.heading ?? 'Building things\nthat matter.';
  const paragraphs = Array.isArray(content?.paragraphs) && content.paragraphs.length > 0
    ? content.paragraphs
    : DEFAULT_PARAGRAPHS;
  const terminalTitle = content?.terminalTitle ?? 'parth@nyc: ~/now';
  const terminalLines = Array.isArray(content?.terminalLines) && content.terminalLines.length > 0
    ? content.terminalLines
    : DEFAULT_TERMINAL_LINES;

  const headingLines = heading.split('\n');

  return (
    <section className="about" id="about">
      <div className="section-inner">
        <span className="section-label">About</span>
        <div className="about-grid">
          <div className="about-text">
            <h2 className="about-heading">
              {headingLines.map((line, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <br />}
                  {line}
                </React.Fragment>
              ))}
            </h2>
            {paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="about-terminal" ref={cardRef}>
            <div className="about-terminal-head">
              <span className="tdot" /><span className="tdot" /><span className="tdot" />
              <span className="about-terminal-title">{terminalTitle}</span>
            </div>
            <div className="about-terminal-body">
              {terminalLines.map((line, i) => (
                <React.Fragment key={i}>
                  <p><span className="t-prompt">$</span> {line.prompt}</p>
                  <p className={line.highlight ? 't-out t-green' : 't-out'}>{line.output}</p>
                </React.Fragment>
              ))}
              <p className="t-cursor"><span className="t-prompt">$</span> <span className="t-blink">▋</span></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
